import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import TextField from '@mui/material/TextField';

interface SearchableTableHeaderProps {
    columnKey: string;
    label: string;
    chartKey: string;
    orderBy: string | undefined;
    order: 'asc' | 'desc' | undefined;
    showSearch: boolean | undefined;
    searchColumn: string | undefined;
    searchTerm: string | undefined;
    onSort: (property: string) => void;
    onSearchClick: () => void;
    onSearchChange: (value: string) => void;
    onSearchBlur: () => void;
    placeholder: string;
}

export const SearchableTableHeader: React.FC<SearchableTableHeaderProps> = ({
    columnKey,
    label,
    chartKey,
    orderBy,
    order,
    showSearch,
    searchColumn,
    searchTerm,
    onSort,
    onSearchClick,
    onSearchChange,
    onSearchBlur,
    placeholder,
}) => {
    const isSearchActive = showSearch && searchColumn === columnKey;

    const columnClass = `data-table-cell ${columnKey === 'fileName' ? 'filename' : columnKey === 'status' ? 'status' : columnKey === 'createdUser' ? 'user' : 'time'}`;

    return (
        <TableCell className={columnClass} sx={{ padding: '0px', fontSize: '12px', borderRight: '1px solid #ccc', whiteSpace: 'nowrap' }}>
            {isSearchActive ? (
                <TextField
                    size="small"
                    variant="outlined"
                    placeholder={placeholder}
                    value={searchTerm || ''}
                    onChange={(e) => onSearchChange(e.target.value)}
                    onBlur={onSearchBlur}
                    autoFocus
                    sx={{
                        marginLeft: '8px',
                        width: '120px',
                        '& .MuiOutlinedInput-root': {
                            height: '24px',
                            fontSize: '11px',
                            backgroundColor: 'white',
                        },
                        '& .MuiOutlinedInput-input': {
                            padding: '4px 8px',
                        },
                    }}
                />
            ) : (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <TableSortLabel
                        active={orderBy === columnKey}
                        direction={order || 'asc'}
                        onClick={() => onSort(columnKey)}
                        sx={{ flexGrow: 1, minWidth: 0 }}
                    >
                        {label}
                    </TableSortLabel>
                    <span
                        style={{ color: '#666', cursor: 'pointer', fontSize: '12px', flexShrink: 0 }}
                        onMouseDown={(e) => {
                            // Run before the active TextField loses focus (blur), otherwise the first click just closes the previous input.
                            e.preventDefault();
                            onSearchClick();
                        }}
                        title={`Search ${label.toLowerCase()}`}
                    >
                        🔍
                    </span>
                </div>
            )}
        </TableCell>
    );
};
